export default __webpack_public_path__ + "static/media/SWT0510.34I-20468_-14789_0.a6c7afd1.jpg";